import axios from 'axios'
import store from '../store'
import router from '../router'

const api = axios.create({
  baseURL: store.state.baseUrl
})

api.interceptors.request.use(config => {
  const token = store.state.token || localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  store.dispatch('showLoader');
  return config;
})

api.interceptors.response.use(
  response => {
    store.dispatch('hideLoader');
    return response;
  },
  error => {
    store.dispatch('hideLoader');

    if (error.response?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      store.commit('SET_TASKBOARD', false);
      router.push('/login')
    }

    return Promise.reject(error);
  }
)

export default api
